module.exports = __webpack_public_path__ + "img/gingerbread-man.40223121.svg";